module.exports = __webpack_public_path__ + "img/quick.e7760183.png";